import { DETAIL_IMAGE_RATIO_OPTIONS } from './options.js';
export const SCHEDULED_BROADCAST_DETAIL_ITEMS = [
    { value: 'type', label: '방송 종류' },
    { value: 'title', label: '제목·배송비' },
    { value: 'categories', label: '카테고리' },
    { value: 'notice', label: '공지' },
];
export const SCHEDULED_BROADCAST_SCREEN_FIELDS = [
    {
        key: 'scheduledBroadcast.list.gridColumns',
        group: '예정 라이브 더보기',
        label: '카드 열 수',
        help: '예정 라이브 더보기 화면(홈 예정 라이브 "더보기")과 검색 화면 예정 라이브 탭에서 한 줄에 놓는 방송 카드 수',
        type: 'integer',
        defaultValue: 2,
        min: 1,
        max: 3,
        unit: '개',
    },
    {
        key: 'scheduledBroadcast.detailImage.aspectRatio',
        group: '예정 라이브 상세(딜러)',
        label: '방송 이미지 비율',
        help: '딜러가 내 예정 라이브를 열었을 때 맨 위 방송 이미지의 가로:세로 비율. 가로는 화면 폭에 맞춘다',
        type: 'enum',
        defaultValue: '1:1',
        options: DETAIL_IMAGE_RATIO_OPTIONS,
    },
    {
        key: 'scheduledBroadcast.detail.order',
        group: '예정 라이브 상세(딜러)',
        label: '정보 줄 순서',
        help: '방송 이미지 아래 정보 줄(방송 종류·제목과 배송비·카테고리·공지)의 순서. 카테고리·공지는 값이 있을 때만 보인다',
        type: 'order',
        defaultValue: SCHEDULED_BROADCAST_DETAIL_ITEMS.map((item) => item.value),
        items: SCHEDULED_BROADCAST_DETAIL_ITEMS,
    },
    {
        key: 'scheduledBroadcast.detail.reminderCountVisible',
        group: '예정 라이브 상세(딜러)',
        label: '알림 신청 수 노출',
        help: '끄면 방송 이미지 아래쪽 띠에서 알림 신청 수(종 아이콘)를 빼고 시작 시각만 보인다',
        type: 'boolean',
        defaultValue: true,
    },
];
//# sourceMappingURL=scheduledBroadcast.js.map